import { Link } from 'react-router-dom';

const featuredItems = [
  {
    title: '恋爱',
    subtitle: '甜宠浪漫',
    slug: 'lianai',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20illustration%20featuring%20a%20couple%20sharing%20an%20umbrella%20under%20cherry%20blossoms%2C%20soft%20pastel%20pink%20color%20palette%2C%20tender%20atmosphere%2C%20webtoon%20style%20cover%20art%2C%20dreamy%20spring%20scene%2C%20beautiful%20character%20design&width=800&height=1100&seq=featured-love&orientation=portrait',
    count: 156,
    color: 'bg-accent-100',
  },
  {
    title: '奇幻',
    subtitle: '魔法冒险',
    slug: 'qihuan',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20illustration%20with%20floating%20islands%20and%20magical%20creatures%2C%20ethereal%20blue%20and%20gold%20color%20scheme%2C%20mystical%20atmosphere%2C%20webtoon%20style%20cover%20art%2C%20epic%20landscape%20with%20castles%20in%20the%20sky&width=800&height=550&seq=featured-fantasy&orientation=landscape',
    count: 134,
    color: 'bg-secondary-100',
  },
  {
    title: '动作',
    subtitle: '热血激战',
    slug: 'dongzuo',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20illustration%20with%20dynamic%20fight%20scene%2C%20two%20warriors%20clashing%20with%20energy%20effects%2C%20dramatic%20red%20and%20orange%20color%20scheme%2C%20webtoon%20style%20cover%20art%2C%20intense%20atmosphere&width=800&height=550&seq=featured-action&orientation=landscape',
    count: 98,
    color: 'bg-primary-100',
  },
];

export default function FeaturedCategories() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-primary-600 mb-3">
            <i className="ri-star-fill text-xs"></i>
            精选分类
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
            发现你的 <span className="text-accent-500">漫画世界</span>
          </h2>
          <p className="mt-2 text-sm text-foreground-500">六大分类，总有一款适合你</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
          <Link
            to={`/category/${featuredItems[0].slug}`}
            className="relative group overflow-hidden rounded-2xl aspect-[3/4] lg:aspect-auto cursor-pointer"
          >
            <img
              src={featuredItems[0].image}
              alt={`${featuredItems[0].title}漫画`}
              title={`哈哈漫画网 - ${featuredItems[0].title}漫画分类`}
              className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 p-5 md:p-6">
              <div className="inline-block px-3 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium mb-2 whitespace-nowrap">
                {featuredItems[0].count}部作品
              </div>
              <h3 className="text-xl md:text-2xl font-heading font-bold text-background-50">{featuredItems[0].title}</h3>
              <p className="text-sm text-background-50/80">{featuredItems[0].subtitle}</p>
            </div>
          </Link>

          <div className="flex flex-col gap-4 md:gap-5">
            {featuredItems.slice(1).map((item) => (
              <Link
                key={item.slug}
                to={`/category/${item.slug}`}
                className="relative group overflow-hidden rounded-2xl flex-1 min-h-[140px] md:min-h-[180px] cursor-pointer"
              >
                <img
                  src={item.image}
                  alt={`${item.title}漫画`}
                  title={`哈哈漫画网 - ${item.title}漫画分类`}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/20 to-transparent"></div>
                <div className="absolute top-0 left-0 p-5 md:p-6">
                  <div className="inline-block px-3 py-1 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-medium mb-2 whitespace-nowrap">
                    {item.count}部作品
                  </div>
                  <h3 className="text-lg md:text-xl font-heading font-bold text-background-50">{item.title}</h3>
                  <p className="text-sm text-background-50/80">{item.subtitle}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}